import { createContext, useCallback, useContext, useReducer } from 'react'

function init() {
  return {
    open: false,
  }
}
const DISPATCH = {
  TOGGLE_OPEN: 'toggle open',
}

const reducer = (state, action) => {
  let { type } = action
  switch (type) {
    case DISPATCH.TOGGLE_OPEN:
      return { ...state, open: !state.open }
    default:
      return state
  }
}

const TableRowContext = createContext()
const TableRowDispatchContext = createContext()

export function TableRowProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, init())
  return (
    <TableRowContext.Provider value={state}>
      <TableRowDispatchContext.Provider value={{ dispatch }}>{children}</TableRowDispatchContext.Provider>
    </TableRowContext.Provider>
  )
}

function useTableRowState() {
  const state = useContext(TableRowContext)
  if (state === undefined) {
    throw new Error('useTableRowState must be used within a TableRowContext')
  }
  return state
}
function useTableRowDispatch() {
  const { dispatch } = useContext(TableRowDispatchContext)
  if (dispatch === undefined) {
    throw new Error('useTableRowDispatch must be used within a TableRowContext')
  }

  const toggleOpen = useCallback(() => {
    dispatch({ type: DISPATCH.TOGGLE_OPEN })
  }, [dispatch])

  return { toggleOpen }
}
export function useTableRow() {
  const { open } = useTableRowState()
  const { toggleOpen } = useTableRowDispatch()
  return {
    open,
    toggleOpen,
  }
}

export default TableRowProvider
